<template class="p-1">
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>mProve</strong> <small>Imported Data</small>
              <div class="ml-3" style="display: inline-flex;">
                From: &nbsp;<date-picker v-model="request.dateStart" :config="dpConfig" style="width: 100px;height: 25px;"></date-picker>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                To: &nbsp;<date-picker v-model="request.dateEnd" :config="dpConfig" style="width: 100px;height: 25px;"></date-picker>
                <a href="#" @click="getData"><i class="ml-3 fa fa-youtube-play" style="font-size: x-large;color: #1f70b5;"></i></a>
              </div>
              <div class="ml-2 pl-5" style="display: inline-flex;text-align:center;" v-show="GetIsNotActiveFeature()">
                <strong>StoneEagle Data</strong>
              </div>
              <div class="pull-right" style="margin-left:50px;display: inline-flex;">
                Deal Count: {{totalRecords}}&nbsp;&nbsp;
              </div>
            </div>

            <b-modal ref="viewfees" title="Details" hide-footer size="lg">
              <b-card>
                <div slot="header">
                  <strong>Products</strong>
                </div>

                <div class="d-block text-center" v-html="currentRow.formattedProducts">
                  {{currentRow.formattedProducts}}
                </div>
              </b-card>

              <b-card>
                <div slot="header">
                  <strong>Fees</strong>
                </div>
                <div class="d-block text-center" v-html="currentRow.formattedFees">
                  {{currentRow.formattedFees}}
                </div>
              </b-card>

              <b-card>
                <div slot="header">
                  <strong>Taxes</strong>
                </div>

                <div class="d-block text-center" v-html="currentRow.formattedTaxes">
                  {{currentRow.formattedTaxes}}
                </div>
              </b-card>
            </b-modal>
            <!--<dx-scrolling mode="virtual" column-rendering-mode="standard" :useNative="true" />-->
            <dx-data-grid v-if="HasRecords" id="grid-container"
                          height="76vh" :paginate="true"
                          :show-borders="true" :wordWrapEnabled="true"
                          :column-auto-width="true" key-expr="id"
                          :show-column-lines="true" :columnFixing="{enabled: true}"
                          :row-alternation-enabled="true" @editor-preparing="editorPreparing"
                          :data-source="records" :columns="columns"
                          :focusedRowEnabled="true">

              <dx-filter-row :visible="true" />
              <dx-filter-panel :visible="true" />
              <dx-filter-builder-popup :position="filterBuilderPopupPosition" />
              <dx-header-filter :visible="true" />
              <dx-scrolling mode="infinite" />

              <dx-editing :allow-updating="true" :use-icons="true" mode="popup">
                <dx-popup :show-title="true" :show-footer="false" title="Imported Data Details" :resizeEnabled="true">
                  <dx-position my="top" at="top" of="window" />
                </dx-popup>
              </dx-editing>

            </dx-data-grid>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { setTimeout } from 'timers'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
// import { DxItem } from 'devextreme-vue/form';

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
// import 'devextreme/dist/css/dx.material.blue.light.css';

import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxHeaderFilter,
  DxFilterRow,
  DxFilterPanel,
  DxFilterBuilderPopup,
  DxMasterDetail,
  DxPager,
  DxPaging,
  DxScrolling,
  DxEditing,
  DxPopup,
  DxLookup,
  DxPosition,
  DxForm,
  DxItem
} from 'devextreme-vue/data-grid'

export default {
  name: 'mprovereport',
  components: {
    loading,
    datePicker,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxSearchPanel,
    DxMasterDetail,
    DxPager,
    DxPaging,
    DxScrolling,
    DxEditing,
    DxPopup,
    DxLookup,
    DxPosition,
    DxForm,
    DxItem
  },
  created () {
    this.initDates()
    this.getData()
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: true,
      txtLoading: 'Loading...',
      currentRow: {},
      records: [],
      columns: ['id', 'se_dealer_id', 'deal_number',
        { caption: 'Deal Date', dataField: 'deal_date', dataType: 'date' }, 'payment_amount',
        'dealer_zip', 'buyer_zip', 'buyer_city',
        'inventory_type', 'contract_type',
        'vehicle_id', 'vehicle_vin', 'vehicle_msrp', 'vehicle_cost', 'vehicle_sell',
        'cash_down', 'mileage_expected',
        'buy_rate', 'sell_rate', 'finance_term', 'residual_value',
        'manufacturer_rebate', 'incentive_rebate',

        'vehicle_odometer', 'buyer_county', 'lender_code', 'lender_name',
        'total_trade_allowance',
        'total_trade_acv', 'total_trade_payoff', 'total_down_payment', 'money_factor', 'money_factor_buy_rate',
        'balloon_amount', 'amount_financed',
        'days_to_first_payment', 'finance_reserve', 'finance_charge', 'invoice_cost',
        'dealer_cash', 'mak_nm', 'mdl_cd', 'mdl_desc', 'mdl_yr', 'trim_desc', 'body_style_desc', 'nci_mak_abbr_cd', 'rps_drv_typ_cd',
        'rps_drv_typ_desc', 'mfg_desc', 'mfg_bas_msrp', 'trk_cab_cnfg_desc', 'deal_status',,
        //, { caption: 'products', dataField: 'products', editorType:"dxTextArea", editorOptions:'{height: 90}', colSpan:'4' }
        'total_fees', 'total_taxes', 'total_taxable_fees', 'total_financed_fees', 'total_option_fees', 'total_init_fees', 'total_annual_fees',
        'total_rebates', 'bank_fee', // 'products', 'fees', 'taxes',
        //, { caption: 'products', dataField: 'products', editorType:"dxTextArea", editorOptions:'{height: 200}', colSpan:'4' }
        'batch_id', 'process_status_type_id',
        { caption: 'Updated', dataField: 'updated', dataType: 'date' },
        { type: 'buttons', buttons: ['edit', { icon: 'rowfield', hint: 'Details', onClick: this.cloneIconClick }] }],
      editButtons: ['edit'],

      request: { dateStart: '2019/01/01', dateEnd: '2019/12/31' },
      totalRecords: 0,
      currentPage: 1,
      perPage: 5,
      IsActiveFeature: true,
      dpConfig: {
        format: 'MM/DD/YYYY',
        useCurrent: false
      },
      filterBuilderPopupPosition: {
        of: window,
        at: 'top',
        my: 'top',
        offset: { y: 10 }
      }
    }
  },
  computed: {
    HasRecords () {
      var self = this
      if (self.records === undefined || self.records.length === 0) {
        return false
      }
      return true
    }
  },
  methods: {
    initDates () {
      var today = new Date()
      var priorDate = new Date().setDate(today.getDate() - 30)
      this.request.dateStart = new Date(priorDate)
      this.request.dateEnd = today
    },
    getRowCount (items) {
      return items.length
    },
    editorPreparing (e) {
      /// /  if (e.parentType === 'dataRow' && e.dataField === 'Position') {@editor-preparing="editorPreparing"
      //    e.editorOptions.readOnly = true;
      /// /  }
    },
    cloneIconClick (e) {
      this.currentRow = Vue.util.extend({}, e.row.data)
      this.currentRow.formattedProducts = "<ul style='list-style-type:none;'>" +
          this.currentRow.products
            .replace(new RegExp('<products>', 'gi'), '')
            .replace(new RegExp('</products>', 'gi'), '')
            .replace(new RegExp('<', 'gi'), '<li>')
            .replace(new RegExp('/>', 'gi'), '</li>') +
          '</ul>'
      this.currentRow.formattedFees = "<ul style='list-style-type:none;'>" +
                                        this.currentRow.fees
                                          .replace(new RegExp('<fees>', 'gi'), '')
                                          .replace(new RegExp('</fees>', 'gi'), '')
                                          .replace(new RegExp('<', 'gi'), '<li>')
                                          .replace(new RegExp('/>', 'gi'), '</li>') +
          '</ul>'
      this.currentRow.formattedTaxes = "<ul style='list-style-type:none;'>" +
          this.currentRow.taxes
            .replace(new RegExp('<taxes>', 'gi'), '')
            .replace(new RegExp('</taxes>', 'gi'), '')
            .replace(new RegExp('<', 'gi'), '<li>')
            .replace(new RegExp('/>', 'gi'), '</li>') +
          '</ul>'
      this.$refs.viewfees.show()
      // e.event.preventDefault();
    },
    getData () {
      this.boolLoading = true
      var self = this
      self.boolLoading = true
      axios.post('/api/mprove/getimporteddata', self.request)
        .then(response => {
          self.showDismissibleAlert = false
          if (response.data.records === undefined || response.data.records == null) {
            self.errMsg = 'No data was returned'
            self.showDismissibleAlert = true
          } else {
            self.records.splice(0)
            let idx = response.data.records.length
            for (let i = 0; i < idx; i++) {
              self.records.push(response.data.records[i])
            }
            self.IsActiveFeature = response.data.mProve.IsActive

            self.totalRecords = this.records.length
          }
          self.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { self.$router.push('/login') }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    GetIsNotActiveFeature () {
      return this.IsActiveFeature === false
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style>

  body {
    background-color: #e4e5e6;
  }

  .breadcrumb {
    display: none !important;
  }

  .main .container-fluid {
    padding: 0.25rem !important;
  }

  .dx-datagrid .dx-row > td {
    font-size: 11px;
  }

  .greenCell {
    background-color: #a0ffad !important;
    color: #000000;
  }

  .redCell {
    background-color: #f88379 !important;
    color: #000000;
  }

  #grid-container tr.main-row td:not(:first-child) {
    height: 21px;
    background-color: #f88379 !important;
  }

  .dx-datagrid-headers .dx-datagrid-table .dx-row > td {
    text-align: center !important
  }

</style>



// WEBPACK FOOTER //
// src/views/mProveRawData.vue